"use client";

import type { ReactNode } from "react";
import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import Box from "@/shared/components/common/Box";
import PhosphorIcon from "@/shared/components/common/PhosphorIcon";

interface NoRoomsAvailableProps {
  title: string;
  description: string;
  icon?: ReactNode;
}

export default function NoRoomsAvailable({
  title,
  description,
  icon,
}: NoRoomsAvailableProps) {
  return (
    <Flex
      direction={"col"}
      className="items-center justify-center p-2 py-3 gap-y-2 border border-primary-20 rounded-xs bg-background"
      id=""
    >
      <Flex className="items-start md:items-center gap-x-4">
        <Box className="md:bg-primary-20 rounded-full flex justify-center items-center p-1 border border-primary-20">
          {icon ? (
            icon
          ) : (
            <PhosphorIcon
              name="Info"
              weight="fill"
              className="w-7 h-7 text-primary"
            />
          )}
        </Box>
        <Typography variant="body3" className="font-normal text-justify">
          {title}
        </Typography>
      </Flex>
      {description && <Typography variant="body2">{description}</Typography>}
    </Flex>
  );
}
